import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const holidayListService = (params: Types.HolidayListRequest) =>
  RestAPIClient.call<Types.HolidayListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const holidayListShortService = (params: {
  month?: number;
  year?: number;
}) =>
  RestAPIClient.call<
    RestAPIResponseList<{
      year: number;
      fromDate: string;
      toDate: string;
      totalDays: number;
    }>
  >({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const holidayCreateService = (params: Types.HolidayCreateRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const holidayUpdateService = (params: Types.HolidayUpdateRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const holidayDetailService = (id: string) =>
  RestAPIClient.call<Types.Holiday>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
